import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { acceptMarketingOffers } from '@sxm-de/dev-kits/web-sdk/domains/agreements';

interface AcceptMarketingAgreementForDeviceLinkingFnPayload {
    language: string;
    marketingConsentVersion: string;
}

export type AcceptMarketingAgreementForDeviceLinkingFn = (
    payload: AcceptMarketingAgreementForDeviceLinkingFnPayload,
) => Promise<unknown>;

export function initAcceptMarketingAgreementForDeviceLinkingFn({
    dependencies,
    countryCodeDefault,
}: DomainInitPayload): AcceptMarketingAgreementForDeviceLinkingFn {
    return async ({
        language,
        marketingConsentVersion,
    }: AcceptMarketingAgreementForDeviceLinkingFnPayload) => {
        await acceptMarketingOffers(
            {
                version: marketingConsentVersion,
                language: language,
                countryCode: countryCodeDefault.toUpperCase(),
            },
            dependencies,
        );
    };
}
